import Vue from "vue"
import App from "./App.vue"
import store from "./store"
import router from "./router"
import VueLazyload from "vue-lazyload"

import { isMobile } from './utils/getSystemIno'
import "./router/routerStack"


Vue.config.productionTip = false

Vue.use(VueLazyload, {
  preLoad: 1.3,
  error: "./static/images/bg_default.png",
  loading: "./static/images/bg_default.png",
  attempt: 1
})

if (process.env.NODE_ENV === "development") {
  require("./jsBridgeSimulate")
}

console.log('isMobile', isMobile())
/**因ios低版本手机不兼容eruda的引入 故使用时再解开注释调试 */
// if (process.env.VUE_APP_RUN_ENV !== "pro") {
//   const eruda = require("eruda")
//   eruda.init()
// }

new Vue({
  store,
  router,
  render: h => h(App)
}).$mount("#app")
